import React, { useEffect, useState } from "react";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import API_URL from "../../../api/API";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import { useParams, useNavigate } from "react-router-dom";
import { DndContext, useDroppable, useDraggable } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import Select from "react-select";

export const ExerciseCreate = () => {
  const { staff } = useStaffAuthContext();
  const { phase_id } = useParams(); // Get the :id from the URL
  const navigate = useNavigate(); // For navigating back to the previous page

  const [phaseName, setPhaseName] = useState(""); // State to store the phase name
  
  const [exerciseId, setExerciseId] = useState("");
  const [exerciseOptions, setExerciseOptions] = useState([]);



  const [isLoading, setIsLoading] = useState(false); // State to manage loading
  const [error, setError] = useState(""); // State to store error messages
  const [successMessage, setSuccessMessage] = useState(""); // State to store success message

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);

  // Fetch phase name using the phase ID
  useEffect(() => {
    const fetchPhaseName = async () => {
      try {
        const response = await fetch(`${API_URL.GET_PHASE_BY_ID}/${phase_id}`, {
          headers: {
            Authorization: `Bearer ${staff.token}` // Include authentication token
          },
        });
        const data = await response.json();

        if (!response.ok) {
          setError(data.error || "Failed to fetch phase details");
        }

        setPhaseName(data.title); // Set the phase name
      } catch (error) {
        setError(error.message);
      }
    };

    fetchPhaseName();
  }, [phase_id, staff.token]);


  useEffect(() => {
  const fetchExercisesLibrary = async () => {
    try {
      const response = await fetch(`${API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${staff.token}`,
        },
      });
      const data = await response.json();
     // console.log(data);

      if (!response.ok) {
        setError(data.error || "Failed to fetch exercises");
        return;
      }

      const exercises = data.exercises.map(exercise => ({
        value: exercise._id,  // Adjust this field based on your response structure
        label: exercise.title,  // Adjust this field based on your response structure
        tags: exercise.tags || [], // Ensure we store tags for filtering
      }));

      setExerciseOptions(exercises);

    } catch (err) {
      setError("An error occurred while fetching exercises.");
    }
  };

      fetchExercisesLibrary();
  });


  // Fetch the saved exercises from the mapped library on the right side. These will be part of the page. 
    const fetchExercisesData = async () => {
      try {
        const response = await fetch(`${API_URL.GET_PHASE_EXERCISE_ALL}${phase_id}?page=1&limit=50`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
        });

        const data = await response.json();

        if (!response.ok) {
          setError(data.error);
        }
        if(response.ok){
         
            setItems(data.phaseExercises);
        }
       
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

useEffect(() => {

    fetchExercisesData();
  }, [staff.token]);

  // Handle drag end logic
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item._id === active.id);
      const newIndex = items.findIndex((item) => item._id === over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        const updatedItems = arrayMove(items, oldIndex, newIndex);
        setItems(updatedItems);
        // Optionally, update order in the database here
        updateOrderInDatabase(updatedItems);
      }
    }
  };

  // Function to update the order in the database
  const updateOrderInDatabase = async (newOrder) => {
    try {
      const response = await fetch(API_URL.UPDATE_PHASE_EXERCISE_ORDER + phase_id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({ exercises: newOrder }),
      });
      if (!response.ok) {
        setError('Failed to update order in database.');
      }
      setSuccess('Order updated successfully.');
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(null), 3000);
    } catch (error) {
      setError(error.message);
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear any existing errors
    setSuccessMessage(""); // Clear any existing success messages
    setIsLoading(true); // Start loading

    try {
      const response = await fetch(`${API_URL.POST_CREATE_PHASE_EXERCISE}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`, // Include authentication token
        },
        body: JSON.stringify({ phase_id: phase_id, exercise_id:exerciseId.value}),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Failed to create exercise");
        return;
      }

      setSuccessMessage("Phase Exercise created successfully!");
    
      // Re-fetch exercises data to update the reorder list
      const updatedExercisesResponse = await fetch(`${API_URL.GET_PHASE_EXERCISE_ALL}${phase_id}?page=1&limit=50`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
      });
      const updatedData = await updatedExercisesResponse.json();
      setItems(updatedData.phaseExercises); // Update the exercises list
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <div className="flex h-screen">
      <StaffSideMenu />

      {/* Main Content */}
      <div className="flex-1 p-6 bg-gray-100 pt-16">
        <h1 className="text-2xl font-bold mb-6">Create Phase Exercise</h1>

        {/* Go Back Button */}
        <button 
          onClick={() => navigate(-1)} 
          className="absolute top-4 right-4 text-white bg-red-500 hover:bg-red-700 px-4 py-2 rounded focus:outline-none"
        >
          Go Back
        </button>

        {/* Show phase name */}
        <p className="text-lg font-semibold mb-4">
          Adding Exercise for Phase:{" "}
          <span className="text-blue-600">{phaseName || "Loading..."}</span>
        </p>

        <div className="flex space-x-8">
          {/* Form Section */}
          <div className="flex-1">
            <form
              onSubmit={handleSubmit}
              className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 max-w-lg mx-auto"
            >
              
              <div className="mb-4">
                <label htmlFor="exerciseId" className="block text-sm font-medium text-gray-700">Select Exercise</label>
                <Select
                id="exerciseId"
                options={exerciseOptions}
                value={exerciseId}
                onChange={setExerciseId}  // Update selected exercise
                placeholder="Select Exercise"
                getOptionLabel={(e) => e.label}
                getOptionValue={(e) => e.value}
                isSearchable
                filterOption={(option, searchText) => {
                  const titleMatch = option.label.toLowerCase().includes(searchText.toLowerCase());
                  const tagsMatch = option.data.tags.some(tag => 
                    tag.toLowerCase().includes(searchText.toLowerCase())
                  );
                  return titleMatch || tagsMatch;
                }}
                required
                className="w-full"
              />
              </div>
           


              {/* Error Message */}
              {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

              {/* Success Message */}
              {successMessage && (
                <p className="text-green-500 text-sm mb-4">{successMessage}</p>
              )}

              {/* Submit Button */}
              <div className="flex items-center justify-between">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`${
                    isLoading ? "bg-blue-300" : "bg-blue-500 hover:bg-blue-700"
                  } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                >
                  {isLoading ? "Creating..." : "Create Phase Exercise"}
                </button>
              </div>
            </form>
          </div>

          {/* Reorder Section */}
          <div className="flex-1">

            {/* Instructional Note */}
            <p className="mb-4 p-4 bg-blue-100 text-blue-700 border-l-4 border-blue-500 rounded-md">
              <strong>Drag and Drop Instructions:</strong> You can reorder the exercises by dragging and dropping the items below. Simply click and drag an exercise to its new position.
            </p>
            <h1 className="text-xl font-semibold mb-4">Reorder Exercises</h1>


            {/* Loading Indicator */}
            {loading && (
              <div className="mb-4 p-4 text-blue-700 bg-blue-100 rounded">
                Loading phases...
              </div>
            )}

            {/* Error Message */}
            {error && (
              <div className="mb-4 p-4 text-red-700 bg-red-100 rounded">
                Error: {error}
              </div>
            )}

            {/* Success Message */}
            {success && (
              <div className="mb-4 p-4 text-green-700 bg-green-100 rounded">
                {success}
              </div>
            )}

            {/* Drag and Drop Context */}
            {!loading && !error && (
              <DndContext onDragEnd={handleDragEnd}>
                <div className="space-y-4">
                  {items.map((item) => (
                    <Droppable key={item._id} id={item._id}>
                      <Draggable id={item._id}>
                        <div className="p-4 border rounded bg-white shadow-sm">
                          {item.title}
                        </div>
                      </Draggable>
                    </Droppable>
                  ))}
                </div>
              </DndContext>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Draggable Component
const Draggable = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {children}
    </div>
  );
};

// Droppable Component
const Droppable = ({ id, children }) => {
  const { setNodeRef } = useDroppable({
    id,
  });

  return <div ref={setNodeRef}>{children}</div>;
};
